// eslint-disable-next-line import/prefer-default-export
export const ROLE_PATH = 'auth.user.role.type';
export const TAGS_PATH = 'auth.user.details.tags';
export const SECRETARY_TAGS_PATH = 'auth.user.details.doctor.tags';
